import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HelpTopicModel } from '~app/models/help-topic.model';
import { HelpTopicEditModel } from '~app/models/requests/help-topic-edit.model';
import { ApiResponseModel } from '~app/models/responses/api-response.model';
import { HelpTopicListModel } from '~app/models/responses/help-topic-list.model';
import { BaseCrudStore } from '~core/abstractions/base-crud.store';
import { StoreConfig } from '~core/models/store.config';

@Injectable({
    providedIn: 'root'
})
export class HelpSubTopicsStore extends BaseCrudStore<HelpTopicModel, HelpTopicListModel, HelpTopicEditModel, HelpTopicEditModel> {
    constructor() {
        super(new StoreConfig({ baseController: 'help-subtopics' }));
    }

    getByHelpTopicId(helpTopicId: number): Observable<ApiResponseModel<HelpTopicListModel[]>> {
        return this._requestService.makeGet<ApiResponseModel<HelpTopicListModel[]>>(this.getUrl(`topic/${helpTopicId}`));
    }

    moveToNewHelpTopic(helpSubTopicId: number, newHelpTopicId: number): Observable<ApiResponseModel<boolean>> {
        return this._requestService.makePut<ApiResponseModel<boolean>>(this.getUrl(`${helpSubTopicId}/set-new-topic/${newHelpTopicId}`));
    }
}
